import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GrundbuchgeschaeftRestDetailEntryMeta } from '../../core/gb-api';
import { Ech0134grundbuchmeldungService, EchGrundbuchmeldungListEntry } from '../../core/grundbuchmeldung-api';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { TableSortModel } from '../../shared/tablesort/tableSortModel';
import { ComparatorService } from '../../shared/services/comparator-service';
import { Ech0134ModuleService } from '../ech0134-module.service';
import { of, Subscription } from 'rxjs';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { Ech0134GrundbuchmeldungTableComponent } from '../grundbuchmeldung/grundbuchmeldung-table/ech0134-grundbuchmeldung-table.component';
import MeldungsrelevantEnum = GrundbuchgeschaeftRestDetailEntryMeta.MeldungsrelevantEnum;

@Component({
  selector: 'cap-ech0134-grundbuchgeschaeft-detail',
  templateUrl: './ech0134-grundbuchgeschaeft-detail.component.html',
  styleUrls: ['./ech0134-grundbuchgeschaeft-detail.component.scss'],
  imports: [Ech0134GrundbuchmeldungTableComponent]
})
export class Ech0134GrundbuchgeschaeftDetailComponent implements OnInit, OnDestroy {
  @Input()
  private geschaeft: GrundbuchgeschaeftRestDetailEntryMeta;
  private listLoader: ListLoader<EchGrundbuchmeldungListEntry>;
  private tableSortModel: TableSortModel<EchGrundbuchmeldungListEntry>;
  private readonly moduleSubscription: Subscription;

  constructor(
    private backend: Ech0134grundbuchmeldungService,
    private comparatorService: ComparatorService,
    private moduleService: Ech0134ModuleService
  ) {
    this.moduleSubscription = moduleService.deleteActionSubject$.subscribe(() => {
      this.load();
    });
  }

  ngOnInit() {
    this.tableSortModel = new TableSortModel<EchGrundbuchmeldungListEntry>('tableId', this.comparatorService);
    this.tableSortModel.addColumn('empfaengerBezeichnung', this.comparatorService.propertyComparator('empfaengerBezeichnung'));
    this.tableSortModel.addColumn('empfaengerSedexId', this.comparatorService.propertyComparator('empfaengerSedexId'));
    this.tableSortModel.addColumn('meldungsStatus', this.comparatorService.propertyComparator('meldungsStatus'));
    this.tableSortModel.addColumn('datumMeldung', this.comparatorService.propertyComparator('datumMeldung'));
    if (this.shouldLoad()) {
      this.load();
    } else {
      this.listLoader = new ListLoaderObservable<EchGrundbuchmeldungListEntry>(undefined, undefined, of([]));
    }
  }

  ngOnDestroy(): void {
    this.moduleSubscription?.unsubscribe();
  }

  shouldLoad(): boolean {
    return this.geschaeft && MeldungsrelevantEnum.JA === this.geschaeft.meldungsrelevant;
  }

  private load() {
    const observable = this.backend.loadMeldungByGeschaeft(this.geschaeft.id.id);
    this.listLoader = new ListLoaderObservable<EchGrundbuchmeldungListEntry>(undefined, undefined, observable);
    this.listLoader.applySortModel(this.tableSortModel);
  }
}
